export const openWhatsApp = (phone, message = '') => {
  if (!phone) return;
  const cleanedPhone = phone.toString().replace(/\D/g, '');
  const url = `https://wa.me/${cleanedPhone}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
  window.open(url, '_blank');
};

export default openWhatsApp;
